<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import LaisCard from 'dashboard/components-next/LaisCard.vue';
import { createRealEstateBrokerCommissionPresenter } from '../composables/realEstateBrokerCommissionPresenter';

const props = defineProps({
  detail: { type: Object, required: true },
});

const { t } = useI18n();
const { money, percentage, roleLabel } =
  createRealEstateBrokerCommissionPresenter(t);
const rows = computed(() => props.detail.rateio || []);
</script>

<template>
  <LaisCard
    :title="t('REAL_ESTATE_BROKER_COMMISSION.BREAKDOWN.TITLE')"
    density="flush"
  >
    <div class="divide-y divide-lais-border-soft">
      <div
        class="hidden grid-cols-[minmax(0,1fr)_9rem_9rem] gap-4 bg-lais-bg-soft px-5 py-3 text-xs font-semibold uppercase tracking-wide text-lais-text-muted sm:grid"
      >
        <span>{{ t('REAL_ESTATE_BROKER_COMMISSION.BREAKDOWN.ROLE') }}</span>
        <span>{{
          t('REAL_ESTATE_BROKER_COMMISSION.BREAKDOWN.PERCENTAGE')
        }}</span>
        <span>{{ t('REAL_ESTATE_BROKER_COMMISSION.BREAKDOWN.VALUE') }}</span>
      </div>
      <article
        v-for="row in rows"
        :key="row.papel"
        class="grid gap-2 px-5 py-4 sm:grid-cols-[minmax(0,1fr)_9rem_9rem] sm:items-center sm:gap-4"
      >
        <p class="font-semibold text-lais-text">{{ roleLabel(row.papel) }}</p>
        <p class="text-sm text-lais-text-body">
          {{ percentage(row.porcentagem) }}
        </p>
        <p class="font-semibold text-lais-text">{{ money(row.valor) }}</p>
      </article>
      <div
        class="grid gap-2 bg-lais-bg-soft px-5 py-4 sm:grid-cols-[minmax(0,1fr)_9rem_9rem] sm:items-center sm:gap-4"
      >
        <p class="font-semibold text-lais-text">
          {{ t('REAL_ESTATE_BROKER_COMMISSION.BREAKDOWN.TOTAL') }}
        </p>
        <span />
        <p class="font-bold text-lais-text">
          {{ money(detail.parcela?.valor_total) }}
        </p>
      </div>
    </div>
  </LaisCard>
</template>
